module.exports = __webpack_public_path__ + "media/images/copaamerica-c3de0185b296b675f99726b8cab3b5fe.jpg";